import React, { useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, FlatList, StyleSheet, Image , ScrollView } from 'react-native';
import Config from "../../Config";
import {Ionicons} from "@expo/vector-icons";
import {RFValue} from "react-native-responsive-fontsize";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import Toast from "../Components/Toast";
import toast from "../Components/Toast";

// const messagesData = [
//     { "id": "1", "text": "سلام، چطور میتونم کمکتون کنم؟", "sender": "support" },
//     { "id": "2", "text": "سلام، در مورد سفارش مشکل دارم.", "sender": "user" },
//     { "id": "3", "text": "لطفا شماره سفارش رو ارسال کنید.", "sender": "support" },
//     { "id": "4", "text": "123456", "sender": "user" },
//     { "id": "5", "text": "سفارش شما بررسی میشه، لطفا صبر کنید.", "sender": "support" },
//     { "id": "6", "text": "ممنون از پیگیریتون.", "sender": "user" },
//     { "id": "7", "text": "خواهش میکنم. آیا سوال دیگه‌ای دارید؟", "sender": "support" },
//     { "id": "8", "text": "خیر، ممنونم. منتظر جواب می‌مونم.", "sender": "user" },
//     { "id": "9", "text": "نتیجه بررسی به زودی به شما اعلام میشه.", "sender": "support" },
//     { "id": "10", "text": "بسیار عالی.", "sender": "user" },
//     { "id": "11", "text": "روزتون بخیر.", "sender": "support" },
//     { "id": "12", "text": "روز شما هم بخیر.", "sender": "user" },
//     { "id": "13", "text": "در صورت نیاز به کمک، دوباره پیام بدید.", "sender": "support" },
//     { "id": "14", "text": "حتما. متشکرم.", "sender": "user" },
//     { "id": "15", "text": "خدانگهدار.", "sender": "support" },
//     { "id": "16", "text": "خدانگهدار.", "sender": "user" },
//     { "id": "17", "text": "سلام، آیا سفارشم ارسال شده؟", "sender": "user" },
//     { "id": "18", "text": "لطفا شماره سفارش رو بفرستید.", "sender": "support" },
//     { "id": "19", "text": "789101", "sender": "user" },
//     { "id": "20", "text": "سفارش شما در حال بسته‌بندی هست.", "sender": "support" },
//     { "id": "21", "text": "چه زمانی به دستم میرسه؟", "sender": "user" },
//     { "id": "22", "text": "احتمالا تا ۳ روز کاری دیگه.", "sender": "support" },
//     { "id": "23", "text": "بسیار عالی، متشکرم.", "sender": "user" },
//     { "id": "24", "text": "خواهش میکنم. روز خوبی داشته باشید.", "sender": "support" }
// ];

export default function Chat({navigation,route}) {
    const [messages, setMessages] = useState(false);
    const [inputMessage, setInputMessage] = useState('');
    const scrollViewRef = React.useRef(null);

    let id = route.params.id;





    const getData = async () => {
        let token = await AsyncStorage.getItem('token');
        let res = await axios.get(`${Config.api}/ticket/chat/${id}`,{ 'headers': {  Authorization: 'Bearer '+token} });

        if(res.data.code != 1){

            Toast(res.data.error);
        }

        setMessages( res.data);
    }

    const sendMessage = async () => {
        if (inputMessage.trim() !== '') {




            let token = await AsyncStorage.getItem('token');

            let formData = new FormData();

            formData.append('text', inputMessage);

            let res = await axios.post(
                `${Config.api}/ticket/sendchat/${id}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Authorization": 'Bearer '+token
                    }
                }
            );

            if(res.data.code != 1){
                // alert(JSON.stringify(res.data));
                // console.log(res.data.data);
                Toast(res.data.error);
            }
            setMessages(res.data);



            // اسکرول به آخرین پیام بعد از رندر شدن
            setTimeout(() => {
                scrollViewRef.current?.scrollToEnd({ animated: true });
            }, 100);
        }
    };


    React.useEffect(() => {
        getData();
    },[id])


    return (
        <View style={styles.container}>
            {messages &&
                <>
                    <View style={styles.header}>
                        <TouchableOpacity style={{flex : 1}} >
                            <Text style={styles.title}>
                                {messages.ticket.subject}
                            </Text>
                        </TouchableOpacity>
                        <TouchableOpacity onPress={()=>{navigation.goBack()}}>
                            <Ionicons style={styles.selficon} name="arrow-back" size={24} color="white" />
                        </TouchableOpacity>
                    </View>
                    <View style={styles.chatContainer}>


                        <ScrollView
                            ref={scrollViewRef}
                            contentContainerStyle={styles.messagesContainer}
                        >
                            {messages.chats.map(item => (
                                <View style={[
                                    styles.messageWrapper,
                                    item.type === 'user' ? styles.userWrapper : styles.supportWrapper
                                ]}>
                                    {item.type === 'admin' && (
                                        <Image  style={styles.avatar}    source={{uri : `${Config.base}/${item.avatar}`}} />
                                    )}
                                    <View style={[
                                        styles.messageContainer,
                                        item.type === 'user' ? styles.userMessage : styles.supportMessage
                                    ]}>
                                        <Text style={styles.messageText}>{item.text}</Text>
                                    </View>
                                    {item.type === 'user' && (
                                        <Image  style={styles.avatar}    source={{uri : `${Config.base}/${item.avatar}`}} />
                                    )}
                                </View>
                            ))}
                        </ScrollView>
                    </View>

                </>

            }
            <View style={styles.inputContainer}>
                <TextInput
                    style={styles.input}
                    placeholder="پیام خود را بنویسید..."
                    value={inputMessage}
                    onChangeText={setInputMessage}
                />
                <TouchableOpacity style={styles.sendButton} onPress={sendMessage}>
                    <Text style={styles.sendButtonText}>ارسال</Text>
                </TouchableOpacity>
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff'
    },



    header: {
        flexDirection : 'row',
        justifyContent : 'flex-start',
        alignItems : 'center',

        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),

        shadowColor:"#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },


    title : {
        fontSize: RFValue(17),
        fontFamily : 'ykb',
        color: '#FFF',
        paddingVertical: RFValue(14),

    },



    chatContainer: {
        flex: 1,
        paddingHorizontal: 10
    },
    messageWrapper: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        marginVertical: 5
    },
    userWrapper: {
        justifyContent: 'flex-end'
    },
    supportWrapper: {
        justifyContent: 'flex-start'
    },
    avatar: {
        width: 40,
        height: 40,
        borderRadius: 20,
        marginHorizontal: 5
    },
    messageContainer: {
        maxWidth: '70%',
        padding: 10,
        borderRadius: 10
    },
    userMessage: {
        backgroundColor: '#FFDC00',
        alignSelf: 'flex-end'
    },
    supportMessage: {
        backgroundColor: '#F2F2F2',
        alignSelf: 'flex-start'
    },
    messageText: {
        fontSize: 16
    },
    inputContainer: {
        flexDirection: 'row',
        padding: 10,
        borderTopWidth: 1,
        borderTopColor: '#E5E5E5'
    },
    input: {
        flex: 1,
        backgroundColor: '#F2F2F2',
        borderRadius: 20,
        paddingHorizontal: 15,
        fontSize: 16,
        direction:'rtl',
        minHeight : RFValue(40),
    },
    sendButton: {
        backgroundColor: '#FFDC00',
        borderRadius: 20,
        paddingHorizontal: 15,
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 10,
        minHeight : RFValue(40),
    },
    sendButtonText: {
        fontSize: 16,
        fontWeight: 'bold'
    }
});
